import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getApiUsages: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGES,
	},
	getApiUsage: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGE,
	},
	getApiUsagePreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGE_PREVIEW,
	},
	getApiUsagePopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGE_POPUP,
	},
}
